/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3NeuronsNeuronIdRequest = {
  neuronId: number;
};

/** @internal */
export const GetApiV3NeuronsNeuronIdRequest$inboundSchema: z.ZodType<
  GetApiV3NeuronsNeuronIdRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  neuron_id: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "neuron_id": "neuronId",
  });
});

/** @internal */
export type GetApiV3NeuronsNeuronIdRequest$Outbound = {
  neuron_id: number;
};

/** @internal */
export const GetApiV3NeuronsNeuronIdRequest$outboundSchema: z.ZodType<
  GetApiV3NeuronsNeuronIdRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3NeuronsNeuronIdRequest
> = z.object({
  neuronId: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    neuronId: "neuron_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3NeuronsNeuronIdRequest$ {
  /** @deprecated use `GetApiV3NeuronsNeuronIdRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3NeuronsNeuronIdRequest$inboundSchema;
  /** @deprecated use `GetApiV3NeuronsNeuronIdRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3NeuronsNeuronIdRequest$outboundSchema;
  /** @deprecated use `GetApiV3NeuronsNeuronIdRequest$Outbound` instead. */
  export type Outbound = GetApiV3NeuronsNeuronIdRequest$Outbound;
}

export function getApiV3NeuronsNeuronIdRequestToJSON(
  getApiV3NeuronsNeuronIdRequest: GetApiV3NeuronsNeuronIdRequest,
): string {
  return JSON.stringify(
    GetApiV3NeuronsNeuronIdRequest$outboundSchema.parse(
      getApiV3NeuronsNeuronIdRequest,
    ),
  );
}

export function getApiV3NeuronsNeuronIdRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3NeuronsNeuronIdRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3NeuronsNeuronIdRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3NeuronsNeuronIdRequest' from JSON`,
  );
}
